// src/services/authService.ts
import envService from './envService';

export interface User {
    sub: string;
    pid: string;
    family_name: string;
    family_name_en: string;
    given_name: string;
    given_name_en: string;
    title: string;
    title_en: string;
    email: string;
}

export interface AuthResponse {
    isAuthenticated: boolean;
    user: User | null;
}

export interface LoginResponse {
    redirectUrl: string;
}

const API_BASE_URL = envService.getApiBaseUrl();

const AUTH_ENDPOINTS = {
    login: `${API_BASE_URL}/api/auth/thaid/login`,
    status: `${API_BASE_URL}/api/auth/thaid/status`,
    logout: `${API_BASE_URL}/api/auth/thaid/logout`
} as const;

export async function initiateLogin(successURL: string, errorURL: string): Promise<void> {
    try {
        const url = `${AUTH_ENDPOINTS.login}?successRedirectURL=${encodeURIComponent(successURL)}&errorRedirectURL=${encodeURIComponent(errorURL)}`;
        const response = await fetch(url, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('ไม่สามารถเริ่มกระบวนการล็อกอินได้');
        }

        const { redirectUrl }: LoginResponse = await response.json();
        window.location.href = redirectUrl;
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ';
        throw new Error(errorMessage);
    }
}

export async function checkAuthStatus(): Promise<AuthResponse> {
    try {
        const response = await fetch(AUTH_ENDPOINTS.status, {
            credentials: 'include'
        });

        if (!response.ok) {
            throw new Error('ไม่สามารถตรวจสอบสถานะการล็อกอินได้');
        }

        const data: AuthResponse = await response.json();
        console.log('Auth Status:', data);
        
        return data;
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ';
        throw new Error(errorMessage);
    }
}

export async function logout(): Promise<void> {
    try {
        await fetch(AUTH_ENDPOINTS.logout, {
            method: 'POST',
            credentials: 'include'
        });
        localStorage.removeItem("userregister");
        const publicUrl = envService.getPublicUrl();
        window.location.href = `${publicUrl}/home`;
    } catch (error) {
        const errorMessage = error instanceof Error ? error.message : 'ไม่สามารถออกจากระบบได้';
        throw new Error(errorMessage);
    }
}

export async function handleLogin(): Promise<void> {
    try {
        const publicUrl = envService.getPublicUrl();
        const successURL = `${window.location.origin}${publicUrl}/login?login_success=true`;
        const errorURL = `${window.location.origin}${publicUrl}/login?login_success=false`;
        await initiateLogin(successURL, errorURL);
    } catch (err) {
        throw err;
    }
}
